import React, { useEffect, useState } from "react";
import { MapPin, X } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

// Free-text city filter with suggestions from every city stored in the database.
export const AdCityFilter = ({ value, onChange, adType, placeholder }) => {
  const [text, setText] = useState(value || "");
  const [open, setOpen] = useState(false);
  const [sugg, setSugg] = useState([]);

  useEffect(() => { setText(value || ""); }, [value]);

  useEffect(() => {
    const q = text.trim();
    const id = setTimeout(() => {
      if (q !== (value || "")) onChange(q);
      if (!q) { setSugg([]); return; }
      api(`/public-ads/cities?ad_type=${adType}&q=${encodeURIComponent(q)}`, { auth: false })
        .then((r) => setSugg(r.cities || [])).catch(() => setSugg([]));
    }, 300);
    return () => clearTimeout(id);
  }, [text, adType]); // eslint-disable-line react-hooks/exhaustive-deps

  const pick = (name) => { setText(name); onChange(name); setOpen(false); };

  return (
    <div className="relative w-52" data-testid="ads-filter-city">
      <MapPin size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
      <Input value={text} placeholder={placeholder} autoComplete="off"
        onChange={(e) => { setText(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)}
        className="pl-9 pr-8 h-12 rounded-full bg-white" data-testid="ads-filter-city-input" />
      {text && (
        <button type="button" onClick={() => pick("")} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700" data-testid="ads-filter-city-clear">
          <X size={15} />
        </button>
      )}
      {open && sugg.length > 0 && (
        <ul className="absolute z-30 mt-1 w-full max-h-64 overflow-auto rounded-2xl border border-border bg-white shadow-lg py-1" data-testid="ads-city-suggestions">
          {sugg.map((c) => (
            <li key={c.name}>
              <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => pick(c.name)}
                className="w-full text-left px-4 py-2 text-sm hover:bg-slate-50 flex justify-between gap-2" data-testid={`ads-city-${c.name}`}>
                <span className="truncate">{c.name}</span><span className="text-slate-400">{c.count}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
